import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "card card-default custom-card-height" }
const _hoisted_3 = { class: "card-header feature-header" }
const _hoisted_4 = { class: "row g-2" }
const _hoisted_5 = { class: "col-auto me-auto" }
const _hoisted_6 = { class: "col-auto" }
const _hoisted_7 = { class: "col-auto" }
const _hoisted_8 = { class: "col-auto" }
const _hoisted_9 = { class: "card-body p-2" }
const _hoisted_10 = { class: "card-body-grid" }
const _hoisted_11 = {
  class: "btn-group actions-row",
  role: "group",
  "aria-label": "Basic example"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  class: "modal fade",
  id: "userModal",
  role: "dialog"
}
const _hoisted_15 = { class: "modal-dialog modal-lg" }
const _hoisted_16 = { class: "modal-content" }
const _hoisted_17 = { class: "modal-header" }
const _hoisted_18 = { class: "modal-title" }
const _hoisted_19 = { class: "modal-body" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col" }
const _hoisted_22 = {
  class: "form-group mt-2 d-flex align-items-center gap-2",
  style: {"border-bottom":"1px solid #ced4da","margin-bottom":"12px","padding-bottom":"10px"}
}
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  for: "isADUser",
  class: "mb-0"
}
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-md-4" }
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = { class: "col-md-4" }
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = { class: "col-md-4" }
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = {
  key: 0,
  class: "col"
}
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { class: "col" }
const _hoisted_42 = { class: "form-group" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = {
  key: 1,
  class: "col"
}
const _hoisted_45 = { class: "form-group" }
const _hoisted_46 = {
  key: 2,
  class: "col"
}
const _hoisted_47 = { class: "form-group" }
const _hoisted_48 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_49 = { class: "col" }
const _hoisted_50 = { class: "d-flex align-items-center gap-2" }
const _hoisted_51 = {
  for: "driveFromPrincipleName",
  class: "mb-0"
}
const _hoisted_52 = { class: "row mt-2" }
const _hoisted_53 = { class: "col" }
const _hoisted_54 = { class: "d-flex align-items-center gap-2" }
const _hoisted_55 = {
  for: "active",
  class: "mb-0"
}
const _hoisted_56 = {
  key: 0,
  class: "col"
}
const _hoisted_57 = { class: "d-flex align-items-center gap-2" }
const _hoisted_58 = {
  for: "resetPassword",
  class: "mb-0"
}
const _hoisted_59 = {
  key: 1,
  class: "row"
}
const _hoisted_60 = { class: "col-md-6" }
const _hoisted_61 = { class: "form-group" }
const _hoisted_62 = ["required"]
const _hoisted_63 = { class: "col-md-6" }
const _hoisted_64 = { class: "form-group" }
const _hoisted_65 = ["required"]
const _hoisted_66 = { class: "row mt-2" }
const _hoisted_67 = { class: "col" }
const _hoisted_68 = { class: "d-flex align-items-center gap-2" }
const _hoisted_69 = {
  for: "enableRenewTokenErrorAlert",
  class: "mb-0"
}
const _hoisted_70 = { class: "modal-footer" }
const _hoisted_71 = {
  type: "submit",
  class: "btn btn-sm btn-outline-info-reverse"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardTitleComponent = _resolveComponent("CardTitleComponent")!
  const _component_SearchComponent = _resolveComponent("SearchComponent")!
  const _component_SubscriptionCommonComponent = _resolveComponent("SubscriptionCommonComponent")!
  const _component_e_column = _resolveComponent("e-column")!
  const _component_e_columns = _resolveComponent("e-columns")!
  const _component_ejs_grid = _resolveComponent("ejs-grid")!
  const _component_ejs_dropdownlist = _resolveComponent("ejs-dropdownlist")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_CardTitleComponent)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_SearchComponent, {
                modelValue: _ctx.searchText,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
                onSearch: _ctx.onSearch,
                onClear: _ctx.clearSearch
              }, null, 8, ["modelValue", "onSearch", "onClear"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.isHost())
                ? (_openBlock(), _createBlock(_component_SubscriptionCommonComponent, {
                    key: 0,
                    onOnSubscription: _ctx.onSubscriptionChange
                  }, null, 8, ["onOnSubscription"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("a", {
                class: "btn btn-outline-primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.open(true)))
              }, [
                _cache[25] || (_cache[25] = _createElementVNode("i", { class: "fas fa-plus me-1" }, null, -1)),
                _createTextVNode(_toDisplayString(_ctx.$t('addNew')), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_ejs_grid, {
              ref: "gridUser",
              dataSource: _ctx.data,
              allowPaging: true,
              allowResizing: true,
              pageSettings: _ctx.pageSettings,
              locale: _ctx.locale,
              rowHeight: 38,
              height: "100%",
              allowSorting: true,
              searchSettings: _ctx.searchOptions,
              dataStateChange: _ctx.dataStateChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_e_columns, null, {
                  default: _withCtx(() => [
                    (_ctx.isHost())
                      ? (_openBlock(), _createBlock(_component_e_column, {
                          key: 0,
                          headerText: _ctx.$t('organization'),
                          field: "Subscription.OrganizationName"
                        }, null, 8, ["headerText"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('firstName'),
                      field: "FirstName"
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('lastName'),
                      field: "LastName"
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('displayName'),
                      field: "DisplayName"
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('email'),
                      field: "Email"
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('role'),
                      field: "roleName",
                      allowSorting: false
                    }, null, 8, ["headerText"]),
                    _createVNode(_component_e_column, {
                      headerText: _ctx.$t('actions'),
                      width: "75",
                      textAlign: "Center",
                      template: 'actionTemplate'
                    }, {
                      actionTemplate: _withCtx(({ data }) => [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("a", {
                            href: "javascript:void(0)",
                            class: "ms-2 action-link action-edit",
                            title: "Edit",
                            onClick: ($event: any) => (_ctx.commandClick('Edit', data))
                          }, [...(_cache[26] || (_cache[26] = [
                            _createElementVNode("i", {
                              class: "e-edit e-icons",
                              style: {"font-size":"0.76em"}
                            }, null, -1)
                          ]))], 8, _hoisted_12),
                          _createElementVNode("a", {
                            href: "javascript:void(0)",
                            class: "ms-2 action-link action-delete",
                            title: "Delete",
                            onClick: ($event: any) => (_ctx.commandClick('Delete', data))
                          }, [...(_cache[27] || (_cache[27] = [
                            _createElementVNode("i", {
                              class: "e-delete e-icons",
                              style: {"font-size":"0.76em"}
                            }, null, -1)
                          ]))], 8, _hoisted_13)
                        ])
                      ]),
                      _: 1
                    }, 8, ["headerText"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["dataSource", "pageSettings", "locale", "searchSettings", "dataStateChange"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("h4", _hoisted_18, _toDisplayString(_ctx.$t('user')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.close()))
            }, [...(_cache[28] || (_cache[28] = [
              _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
            ]))])
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.onUpsert && _ctx.onUpsert(...args)))
          }, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _withDirectives(_createElementVNode("input", {
                      disabled: _ctx.isUpdate,
                      type: "checkbox",
                      id: "isADUser",
                      class: "checkbox",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.isADUser) = $event)),
                      onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onADUserChange && _ctx.onADUserChange(...args)))
                    }, null, 40, _hoisted_23), [
                      [_vModelCheckbox, _ctx.form.isADUser]
                    ]),
                    _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('microsoftEntraUser')), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("label", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('customer')) + " ", 1),
                      _cache[29] || (_cache[29] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                    ]),
                    _createVNode(_component_ejs_dropdownlist, {
                      id: "customerTree",
                      modelValue: _ctx.form.subscriptionId,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.subscriptionId) = $event)),
                      dataSource: _ctx.listSubscription,
                      fields: _ctx.fieldsSubscription,
                      placeholder: _ctx.$t("msgSelectCustomer"),
                      onSelect: _ctx.onSelectCustomer
                    }, null, 8, ["modelValue", "dataSource", "fields", "placeholder", "onSelect"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("label", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('role')) + " ", 1),
                      _cache[30] || (_cache[30] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                    ]),
                    _createVNode(_component_ejs_dropdownlist, {
                      id: "roleTree",
                      modelValue: _ctx.form.roleId,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.roleId) = $event)),
                      dataSource: _ctx.listRole,
                      fields: _ctx.fieldsRole,
                      placeholder: _ctx.$t("msgSelectRole")
                    }, null, 8, ["modelValue", "dataSource", "fields", "placeholder"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("label", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('first') + ' ' + _ctx.$t('name')) + " ", 1),
                      _cache[31] || (_cache[31] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control input-sm",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.firstName) = $event)),
                      required: "",
                      onInput: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onNameChange && _ctx.onNameChange(...args)))
                    }, null, 544), [
                      [_vModelText, _ctx.form.firstName]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("label", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('last') + ' ' + _ctx.$t('name')) + " ", 1),
                      _cache[32] || (_cache[32] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control input-sm",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.lastName) = $event)),
                      required: "",
                      onInput: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onNameChange && _ctx.onNameChange(...args)))
                    }, null, 544), [
                      [_vModelText, _ctx.form.lastName]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("label", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('displayName')) + " ", 1),
                      _cache[33] || (_cache[33] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control input-sm",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.displayName) = $event)),
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.form.displayName]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                (_ctx.form.isADUser)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("label", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('user')) + " " + _toDisplayString(_ctx.$t('principleName')) + " ", 1),
                          _cache[34] || (_cache[34] = _createElementVNode("span", { class: "text-danger" }, "* ", -1))
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          type: "email",
                          class: "form-control input-sm",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.principleName) = $event)),
                          disabled: _ctx.isUpdate,
                          required: "",
                          onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.principleNameInput()))
                        }, null, 40, _hoisted_40), [
                          [_vModelText, _ctx.form.principleName]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("label", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('email')) + " ", 1),
                      _cache[35] || (_cache[35] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      class: "form-control input-sm",
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.email) = $event)),
                      disabled: _ctx.isUpdate || (_ctx.form.isADUser && _ctx.form.driveFromPrincipleName),
                      required: ""
                    }, null, 8, _hoisted_43), [
                      [_vModelText, _ctx.form.email]
                    ])
                  ])
                ]),
                (!_ctx.isUpdate && !_ctx.form.isADUser)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("label", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('password')) + " ", 1),
                          _cache[36] || (_cache[36] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          type: "password",
                          class: "form-control input-sm",
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.password) = $event)),
                          required: ""
                        }, null, 512), [
                          [_vModelText, _ctx.form.password]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isUpdate && !_ctx.form.isADUser)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("label", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('confirmPassword')) + " ", 1),
                          _cache[37] || (_cache[37] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          type: "password",
                          class: "form-control input-sm",
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.confirmPassword) = $event)),
                          required: ""
                        }, null, 512), [
                          [_vModelText, _ctx.form.confirmPassword]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.form.isADUser && !_ctx.isUpdate)
                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: "driveFromPrincipleName",
                          class: "checkbox",
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.driveFromPrincipleName) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.form.driveFromPrincipleName]
                        ]),
                        _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.$t('driveFromPrincipleName')), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "active",
                      class: "checkbox",
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.isActive) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.isActive]
                    ]),
                    _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.$t('active')), 1)
                  ])
                ]),
                (_ctx.isUpdate && !_ctx.form.isADUser)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: "resetPassword",
                          class: "checkbox",
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.resetPassword) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.form.resetPassword]
                        ]),
                        _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.$t('Reset Password')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.isUpdate && _ctx.form.resetPassword)
                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("label", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('password')) + " ", 1),
                          _cache[38] || (_cache[38] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          type: "password",
                          class: "form-control input-sm",
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.password) = $event)),
                          required: _ctx.form.resetPassword
                        }, null, 8, _hoisted_62), [
                          [_vModelText, _ctx.form.password]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("label", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('confirmPassword')) + " ", 1),
                          _cache[39] || (_cache[39] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          type: "password",
                          class: "form-control input-sm",
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.confirmPassword) = $event)),
                          required: _ctx.form.resetPassword
                        }, null, 8, _hoisted_65), [
                          [_vModelText, _ctx.form.confirmPassword]
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("div", _hoisted_68, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "enableRenewTokenErrorAlert",
                      class: "checkbox",
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.enableErrorAlert) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.enableErrorAlert]
                    ]),
                    _createElementVNode("label", _hoisted_69, _toDisplayString(_ctx.$t('enableRenewTokenErrorAlert')), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-outline-close",
                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.close()))
              }, [
                _cache[40] || (_cache[40] = _createElementVNode("i", { class: "fas fa-times" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('close')), 1)
              ]),
              _createElementVNode("button", _hoisted_71, [
                _cache[41] || (_cache[41] = _createElementVNode("i", { class: "fas fa-save" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.isUpdate ? _ctx.$t('update') : _ctx.$t('save')), 1)
              ])
            ])
          ], 32)
        ])
      ])
    ])
  ], 64))
}